import { render, staticRenderFns } from "./DiscountPopUp.vue?vue&type=template&id=22396fca&scoped=true"
import script from "./DiscountPopUp.vue?vue&type=script&lang=js"
export * from "./DiscountPopUp.vue?vue&type=script&lang=js"
import style0 from "./DiscountPopUp.vue?vue&type=style&index=0&id=22396fca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22396fca",
  null
  
)

export default component.exports